<template>
  <div>  
    <br/> 
    <ListaEsperaEdit ref="listaEsperaEdit" @input="consulta"/>


    <v-row><v-col sm="6" md="4">
      <v-text-field v-model="search" v-if="num_filas>5" :label="$t('buscarListaEspera')" append-icon="search" @input="consulta" outlined></v-text-field></v-col>
    </v-row>
    <v-card outlined elevation="1">                  
    <v-data-table  v-if="num_filas>0" :headers="cabecera" :items="listaEspera" :search="search" :custom-filter="buscaTabla" 
            :hide-default-footer="filas_mostradas<=10">

        <template v-slot:item="row">
            <tr>
              <td>{{row.item.persona.nombre}} {{row.item.persona.apellidos}} </td>
              <td class="d-none d-sm-table-cell">{{row.item.agendaDef.nombre}}</td>
              <td class="d-none d-md-table-cell">{{date_to_char(row.item.fecha,"dd/mm/yyyy")}}</td>
              <td class="d-none d-md-table-cell">{{row.item.acto.nombre}}</td>
              <td class="d-none d-md-table-cell">
                <span :class="clase_urgencia(row.item.urgencia)">{{texto_urgencia(row.item.urgencia)}}</span>
              </td>
              <td class="d-none d-md-table-cell">{{row.item.descripcion}}</td>
              <td>
                  <v-btn class="mx-2" fab dark small color="primary" @click="editar(row.item.cod)">
                      <v-icon dark>edit</v-icon>
                  </v-btn>
              </td>            
            </tr>
        </template>
      </v-data-table>
    <div v-if="num_filas==0"><h1>{{$i18n.t('NOLISTAESPERA')}}</h1></div>
    </v-card>
  
</div>
</template>



<script>

import {mapState, mapMutations} from 'vuex';
import {date_to_char,getListaEspera} from '@/library/misFunciones.js';
import ListaEsperaEdit from '@/components/ListaEsperaEdit.vue';


export default {
  name: 'ListaEspera',
  components: { ListaEsperaEdit },
  data() {
    return {
        cabecera: [
            { text: this.$i18n.t('paciente'), value: 'paciente' },
            { text: this.$i18n.t('agenda'), value: 'agendaDef',class:'d-none d-sm-table-cell'},
            { text: this.$i18n.t('fecha'), value: 'fecha',class:'d-none d-md-table-cell'},
            { text: this.$i18n.t('acto'), value: 'acto',class:'d-none d-md-table-cell'},
            { text: this.$i18n.t('urgencia'), value: 'urgencia',class:'d-none d-md-table-cell'},
            { text: this.$i18n.t('datosadicionales'), value: 'descripcion',class:'d-none d-md-table-cell'},
            { text: this.$i18n.t('editar'), value: 'editar',sortable: false }],
        // datos: [],
        search: '',
        filas_mostradas:11,
        listaEspera: [],
        // num_filas: -1
  }},
  computed: {
    ...mapState(['sesion']),
    // nueva_persona() {return this.sesion.nueva_persona},
    num_filas() {return this.listaEspera.length},
  },
  methods: {
    date_to_char,
    getListaEspera,
    ...mapMutations(['mostrarLoading','ocultarLoading','mostrarError']),
    async consulta() {
      if (this.search.length===0) this.filas_mostradas = 11;
      else this.filas_mostradas = 0;
      this.listaEspera = await this.getListaEspera(true);
    },
    buscaTabla(value, search, item) {
      //console.log(item)
       if (item.npaciente.toUpperCase().indexOf(search.toUpperCase())>=0 ||
           item.nagendaDef.toUpperCase().indexOf(search.toUpperCase())>=0 ||
           item.nacto && item.nacto.toUpperCase().indexOf(search.toUpperCase())>=0 ||
           item.descripcion.toUpperCase().indexOf(search.toUpperCase())>=0) {
         this.filas_mostradas ++;
         return true;
       }
       else return false;
    },
    // nuevo(agendaDef) {
    //   this.$refs.personaEdit.nuevo(agendaDef);
    // },
    editar(id) {
      this.$refs.listaEsperaEdit.editar(id);
    },
    // eliminar(id) {
    //   this.$refs.personaEdit.editar(id,true);
    // }  
    // verCitas(cod,nombre,apellidos) {
    //   this.$refs.personaCitas.abrir(cod,nombre,apellidos);
    // }

    texto_urgencia(urgencia) {
        switch (urgencia) {
        case 'N':
            return this.$i18n.t('nourgente');
        case 'A':
            return this.$i18n.t('algourgente');
        case 'M':
            return this.$i18n.t('muyurgente');
        default:
            return '';
        }
    },
    clase_urgencia(urgencia) {
      if (urgencia === 'N') return 'urgenciaVerde';
      if (urgencia === 'A') return 'urgenciaNaranja';
      if (urgencia === 'M') return 'urgenciaRoja';
      return '';
    },

  },
  mounted(){
    this.sesion.rutaActual = "listaEspera";
    this.consulta()
    // console.log("mounted listaEspera",this.listaEspera)
  },
  watch: {
    // nueva_persona(val) {
    //     if (val) this.nuevo('');
    //     this.sesion.nueva_persona = false;
    // },
  },
   
 
}
</script>

<style scoped>

.urgenciaVerde {
  color: #2e7d32;
  font-weight: 600;
}



.urgenciaNaranja {
  color: #ef6c00;
  font-weight: 600;
}

.urgenciaRoja {
  color: #c62828;
  font-weight: 600;
}




</style>